import PageNotFoundImage from '../assets/pagenotfound.png'
import { Link } from "react-router-dom";
import { Button } from "../components";
import { useEffect } from 'react';

export const PageNotFound = () => {

  useEffect(() => {
    document.title = `Page Not Found / CineWave`
  })

  return (
    <main>
      <section className="flex flex-col justify-center px-2"> 
        <div className="flex flex-col items-center my-4">
          <p className="text-7xl text-gray-700 font-bold my-10 dark:text-white"> 404, Oops </p>
          
          <div className="max-w-lg"> 
            <img src={PageNotFoundImage} alt="404 Page Not Found" className="rounded" />
          </div>
        </div>
      </section>
      
      <section className="flex justify-center my-4">
        <Link to="/">
          <Button> 
            Back To CineWave
          </Button>
        </Link>
      </section>
    </main>
  )
}
